<template>
  <div id="contact">

    <div class="container">

      <div class="row">

        <div class="col-md-12">
          <div class="title">
            Entre em <span>Contato</span>
          </div>
          <p>Adoramos receber mensagens, críticas e sugestões! Abra seu coração e fale conosco.</p>
          <p>Nossa plataforma está sempre em evolução e com o seu apoio poderemos construir a melhor
            ferramenta de transformação e impacto social.</p>
        </div>
        <div class="col-md-12 form-msg" v-if="msgError || msgSuccess">
          <small class="error" v-if="msgError">{{msgError}}</small>
          <small class="success" v-if="msgSuccess">{{msgSuccess}}</small>
        </div>
        <form v-if="!loading">
          <div class="col-md-12">
            <div class="form-row">
              <div class="col">
                <div class="form-group">
                  <input class="form-control" v-model="name" type="nome" name="nome" placeholder="Nome" />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <input class="form-control" v-model="email" type="email" name="email" placeholder="E-mail" />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 form-group">
            <textarea class="form-control" placeholder="Mensagem" v-model="message"></textarea>
          </div>

          <div class="col-md-12 form-group">
            <button class="btn" v-on:click.stop.prevent="submit()">ENVIAR</button>
          </div>
        </form>
        <div class="col-md-12" v-else>
          <h5>Aguarde, enviando...</h5>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { API } from '../../services/api'
import Functions from '../../utils/functions'

export default{
  data(){
    return {
      name: null,
      email: null,
      message: null,
      loading: false,
      msgSuccess: null,
      msgError: null
    }
  },
  methods: {
    submit(){
      this.loading = true;
      if(this.validate()){
        this.$http.post(API.Contact.contact, {name: this.name, email: this.email, message: this.message})
        .then((res) => {
          this.msgSuccess = res.body.message;
          this.loading = false;
          this.name = null;
          this.email = null;
          this.message = null;
        }, (err) => {
          this.msgError = err.body.message;
          this.loading = false;
        });
      }else{
        this.loading = false;
      }
    },
    validate(){
      if(!this.name){
        this.msgError = 'Deve informar o seu nome!';
        return false;
      }
      if(!this.email){
        this.msgError = 'Deve informar um e-mail!';
        return false;
      }
      if(!Functions.validateEmail(this.email)){
        this.msgError = 'Deve informar um e-mail válido!';
        return false;
      }
      if(!this.message){
        this.msgError = 'Digite uma mensagem!';
        return false;
      }
      return true;
    }
  }
}
</script>

<style scoped lang="scss">
#contact{
  min-height: 300px;
  background-color: #f4f4f4;
  padding-bottom: 20px;

  @media screen and (max-width: 767px ){
    display: none;
    padding-bottom: 0px;
  }

  .title{
    margin-top: 40px;
    font-size: 28px;
    font-family: RalewayRegular;

    span{
      color: #00AE39;
    }
  }

  .form-msg{
    .error{
      color: red;
      font-size: 16px;
    }

    .success{
      color: #00AE39;
      font-size: 16px;
    }
  }

  form{
    display: block;
    width: 100%;
    height: auto;
    margin-top: 10px;

    input{
      font-family: RalewayRegular;
      font-size: 18px;
      border-color: #ddd;
      padding: 15px;
      padding-top: 30px;
      padding-bottom: 30px;
    }

    textarea{
      font-family: RalewayRegular;
      font-size: 18px;
      resize: none;
      height: 100px;
      border-color: #ddd;
      padding: 15px;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    button{
      padding: 10px;
      padding-left: 50px;
      padding-right: 50px;
      border-radius: 5px;
      border-color: transparent;
      background-color:#00AE39;
      color: #fff;
      font-family: RalewayRegular;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/ContactSection.vue